export default __webpack_public_path__ + "static/media/proj3_7.6b0461a8.jpg";